<template>
  <section>
    <div>
      <div class="path">
        <booking-stages :appointment="appointment" :stage="stage" @setStage="setStage" />
      </div>

      <div>
        <Transition>
          <booking-service
            v-if="stage === 'service'" v-show="!isGettingData"
            :appointment="appointment"
            @stage="setStage"
            @selectService="selectService"
          />
          <booking-location
            v-else-if="stage === 'location'"
            :appointment="appointment"
            @stage="setStage"
            @selectPractice="selectPractice"
          />
          <booking-date
            v-else-if="stage === 'date'"
            :appointment="appointment"
            @stage="setStage"
            @selectDate="selectDate"
          />
          <booking-customer
            v-else-if="stage === 'customer'"
            :appointment="appointment"
            @stage="setStage"
            @updateCustomer="updateCustomer"
          />
        </Transition>
      </div>
    </div>
  </section>
</template>

<script>
import BookingCustomer from "../components/BookingCustomer.vue";
import BookingDate from "../components/BookingDate.vue";
import BookingLocation from "../components/BookingLocation.vue";
import BookingService from "../components/BookingService.vue";
import BookingStages from '../components/BookingStages.vue';
// @ is an alias to /src

export default {
  created() {
    this.currentURL = location.host;
  },

  components: { BookingService, BookingLocation, BookingDate, BookingCustomer, BookingStages },
  name: "BookingView",
  data() {
    return {
      currentURL: "",
      stage: 'service',
      emptyPractice: {
        "ID": 0,
        "post_title": "",
        "post_name": "",
        "ad_location_id": "",
        "ad_address": "",
        "ad_latlng": "",
        "ad_time_slots": [],
        "distance": 0,
        "has_next_appointment": false,
        "next_appointment_info": ""
      },
      appointment: {
        service: {
          code: '',
          title: '',
          id: '',
          duration: 0,
          price: ''
        },//object
        practice: {"ID": 0},
        date: {
          id: "",//id string
          time: "",//3:00 pm
          date: "", //Monday 14 June,
          calendar_date: "" //2022-04-3 12:30:05
        },
        customer: {
          firstname: "",
          lastname: "",
          dob: {
            year: "",
            month: "",
            day: ""
          },
          email: "",
          phone: "",
          extra: "",
          signup: {
            email: false,
            sms: false,
            post: false,
          },
          privacy: false,
        },
        services: [],
        practices: [],
        bookingConfigs: null,//an object
      },

      selectedPracticeName: "",//going from the main site i.e: ?practice=cirencester
      selectedServiceName: "",//going from the main site i.e: ?service=Full Hearing Assessment
      fullServices: [],
      practiceOfferredServices: [],
      isGettingData: true,
    };
  },
  mounted() {
    // Do we have preselect dat
    /* Do data preflight before loading stuff */
    this.practice = this.emptyPractice;
    if (this.$route.query.service) {
      this.selectedServiceName = this.htmlDecode(decodeURIComponent(this.$route.query.service).toLowerCase());
    }

    if (this.$route.query.practice) {
      this.selectedPracticeName = this.htmlDecode(this.$route.query.practice.toLowerCase());
    }

    // Get initial booking data from API
    this.getInitialBookingData();
  },
  methods: {
    // Get initial booking data from API
    getInitialBookingData() {
      // Get initial booking data from API
      this.axios
        .get("/wp-json/leightons/v1/start-booking")
        .then((response) => {
          this.appointment.services = response.data.services;
          this.appointment.practices = response.data.practices;
          this.appointment.bookingConfigs = response.data.configuration;
          this.fullServices = response.data.services;
          // this.practiceOfferredServices = response.data.practiceOfferredServices;

          // this.fullServices = this.appointment.services;

          // If we have a service selected through the query string, find it and select it
          if (this.selectedServiceName) {
            const foundService = this.appointment.services.find((p) => {
              return this.htmlDecode(p.id).toLowerCase() === this.selectedServiceName;
            });

            if (foundService) {
              this.selectService(foundService);
            }
          }

          // set active location to selectedPracticeName if valid
          if (this.selectedPracticeName != "") {
            const foundLocation = this.appointment.practices.find((p) => p.post_name == this.selectedPracticeName);
            if (foundLocation) {
              const service_codes = foundLocation.service_codes;
              if (service_codes && service_codes.length > 0) {
                this.practiceOfferredServices = this.appointment.services.filter((p) => service_codes.indexOf(p.code) > -1);
              }

              this.selectPractice(foundLocation);
            }
          }

          //journey ways to book
          if (this.appointment.practice.ID != 0 && this.appointment.service.id != "") {
            this.setStage('date');
          } else if (this.appointment.service.id != "") {
            this.setStage('location');
          }

        })
        .catch((error) => {
          // console.log(error);
        })
        .finally(() => {
          this.isGettingData = false;
        });
    },
    htmlDecode(input){
      const e = document.createElement('textarea');
      e.innerHTML = input;
      return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    },
    selectService(service) {
      //check to reset practice + date as well
      if (this.appointment.service.code != '' && this.appointment.service.code !== service.code) {
        //set active location to selectedPracticeName if valid
        if (this.selectedPracticeName != "" && this.appointment.practice.post_name === this.selectedPracticeName) {
          // still keep the selected practice
        } else { //if not, reset
          this.selectPractice(this.emptyPractice);
        }

        this.selectDate({
          id: "",//id string
          time: "",//3:00 pm
          date: "" //Monday 14 June
        });
      }
      this.appointment.service = service;
    },
    selectPractice(practice) {
      //check to reset date as well
      if (practice && this.appointment.practice.ID != 0 && this.appointment.practice.ID !== practice.ID) {
        this.selectDate({
          id: "",//id string
          time: "",//3:00 pm
          date: "" //Monday 14 June
        });
      }
      if (!practice) {
        practice = this.emptyPractice;
      }
      this.appointment.practice = practice;

      if (this.selectedPracticeName != "") {
        //reset the services list if user exits the booking journey from a practice by choosing another practice
        if (practice.post_name != this.selectedPracticeName) {
          this.appointment.services = this.fullServices;
        } else {
          //only showing the services that practice offers
          if (this.practiceOfferredServices.length > 0) {
            this.appointment.services = this.practiceOfferredServices;
          }
        }
      }
    },
    selectDate(date) {
      this.appointment.date = date;
    },
    updateCustomer(customer) {
      this.appointment.customer = customer;
    },
    setStage(stage) {
      this.stage = stage;
    },
    addToGTMDataLayer() {
      if (this.appointment.services && this.appointment.services.length > 0) {

        let dataLayerServices = [];
        this.appointment.services.map((item, index) => {
          dataLayerServices.push({
              'name': item.title,
              'id': item.id,
              'price': item.price ?? '',
              'brand': 'Leightons Opticians & Hearing Care',
              'category': '',
              'list': 'Booking Type',
              'position': index+1
           });
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'eec.impressionView',
          'ecommerce': {
            'currencyCode': 'GBP',
            'impressions': dataLayerServices
          }
        });
      }
    }
  },
};
</script>

<style lang="postcss" scoped>
section {

  .heading-container {
    @apply flex justify-center bg-white p-7 py-9 items-center;

    img:first-of-type {
      @apply mr-[30px];
    }

    img:last-of-type {
      @apply ml-[30px] transform rotate-180;
    }
  }
  h1 {

    .line-break::after{
      @apply whitespace-pre sm:whitespace-normal;

      content: "\a";
    }
  }
}
</style>